/**
 * Issue 4.1: Wrap async operations with timeout protection
 * Prevents indefinite hangs when network is slow or unavailable
 * @param {Promise} promise - The async operation to protect
 * @param {number} timeoutMs - Timeout in milliseconds (default: 10000ms)
 * @param {string} label - Operation label for error messages
 * @returns {Promise} Rejects with timeout error if operation takes too long
 */
export async function withTimeout(promise, timeoutMs = 10000, label = 'Operation') {
    let timeoutId;
    
    const timeoutPromise = new Promise((_, reject) =>
        timeoutId = setTimeout(() => {
            reject(new Error(`${label} timed out after ${timeoutMs}ms`));
        }, timeoutMs)
    );
    
    try {
        return await Promise.race([promise, timeoutPromise]);
    } finally {
        clearTimeout(timeoutId);
    }
}
